import { createApi } from "@reduxjs/toolkit/query/react";
import { awsBaseQuery } from "../../config/awsBaseQuery";
import { HttpMethod } from "../../config/interfaces";
import { Transaction, TransactionResponse } from "./interfaces";
import TConfig from "../../../../../../config";

export const transactionsApi = createApi({
  reducerPath: "transactions",
  baseQuery: awsBaseQuery(),
  tagTypes: ["Transaction"],
  endpoints: (builder) => ({
    getTransactionById: builder.query<Transaction, { transactionId: string }>({
      query: ({ transactionId }) => ({
        path: `${TConfig.webapp.TRANSACTION_API_ENDPOINT}/${transactionId}`,
        method: HttpMethod.GET,
      }),
      transformResponse: (response: TransactionResponse): Transaction => response.transaction,
      providesTags: ["Transaction"],
    }),
    updateTransaction: builder.mutation<
      Transaction,
      { transactionId: string; body: Partial<Transaction> }
    >({
      query: ({ transactionId, body }) => ({
        path: `${TConfig.webapp.TRANSACTION_API_ENDPOINT}/${transactionId}`,
        method: HttpMethod.PATCH,
        data: {
          body,
        },
      }),
      transformResponse: (response: TransactionResponse): Transaction => response.transaction,
      invalidatesTags: ["Transaction"],
    }),
  }),
});

export const { useGetTransactionByIdQuery, useUpdateTransactionMutation } = transactionsApi;
